import { z } from "zod";

export const HealthReportSchema = z.object({
  blood_pressure_systolic: z.coerce.string().optional(),
  blood_pressure_diastolic: z.coerce.string().optional(),
  blood_sugar_random: z.coerce.string().optional(),
  bmi: z.coerce.string().optional(),
  body_fat: z.coerce.string().optional(),
  muscle_mass: z.coerce.string().optional(),
  muscle_rate: z.coerce.string().optional(),
  skeletal_muscle_mass: z.coerce.string().optional(),
  body_water: z.coerce.string().optional(),
  bone_mass: z.coerce.string().optional(),
  bmr: z.coerce.string().optional(),
  metabolic_age: z.coerce.string().optional(),
  visceral_fat: z.coerce.string().optional(),
  subcutaneous_fat: z.coerce.string().optional(),
  protein_mass: z.coerce.string().optional(),
  weight_witout_fat: z.coerce.string().optional(),
  obesity_level: z.coerce.string().optional(),
  pulse_rate: z.coerce.string().optional(),
  body_weight: z.coerce.string().optional(),
  ideal_body_weight: z.coerce.string().optional(),
  water_weight: z.coerce.string().optional(),
  obesity_grade: z.coerce.string().optional(),
  fat_mass: z.coerce.string().optional(),
  body_score: z.coerce.string().optional(),

  medical_history: z.string().optional(),
  medication: z.string().optional(),
  activity_level: z.string().optional(),
});

export type HealthReportdata = z.infer<typeof HealthReportSchema>;

export const EditHealthReportSchema = HealthReportSchema.partial();

export type EditHealthReportFormValues = z.infer<typeof EditHealthReportSchema>;
